import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

var Ft = /*#__PURE__*/function () {
  function Ft(t, s, i, h, l, e, r, u) {
    _classCallCheck(this, Ft);

    this.ul = t || 0, this.vl = s || [], this.wl = i || [], this.Cl = h || [], this.jl = l, null != l && "" !== l || (this.jl = null), this.gl = e || null, this.ml = r || {}, this.cl = u || {};
  }

  _createClass(Ft, [{
    key: "ss",
    value: function ss() {
      return {
        s: "4.3.0",
        l: this.ul,
        e: this.vl,
        a: this.wl,
        p: this.Cl,
        m: this.jl,
        v: this.gl,
        c: this.ml,
        f: this.cl
      };
    }
  }], [{
    key: "yn",
    value: function yn(t) {
      var s = t.l;
      return "4.3.0" !== t.s && (s = 0), new Ft(s, t.e, t.a, t.p, t.m, t.v, t.c, t.f);
    }
  }]);

  return Ft;
}();

export { Ft as default };